import axiosHelper from '@/utils/axiosHelper'

export default {
  // 获取表格结构信息
  getColumnInfo: async function (tableCode) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.GetTableColumns', {
      tableCode: tableCode
    })
    if (rtnObj.error === '000000') {
      const columnInfo = rtnObj.tableColumns
      const disPlayColumnInfo = []
      const tableInfo = rtnObj.tableInfo
      let orderStr = ''
      const orderKeys = []
      for (let i = 0; i < columnInfo.length; i++) {
        const column = columnInfo[i]
        if (column.DisplayFlag === '1') {
          disPlayColumnInfo.push(column)
        }
        if (column.OrderType === '1') {
          orderKeys.push(
            {
              columnCode: column.ColumnCode,
              orderType: 'ASC',
              orderSeq: column.OrderSeq
            })
        } else if (column.OrderType === '2') {
          orderKeys.push(
            {
              columnCode: column.ColumnCode,
              orderType: 'DESC',
              orderSeq: column.OrderSeq
            })
        }
      }
      orderKeys.sort(function (a, b) {
        a = a.orderSeq
        b = b.orderSeq
        if (a < b) {
          return -1
        }
        if (a > b) {
          return 1
        }
        return 0
      })
      for (let i = 0; i < orderKeys.length; i++) {
        orderStr += orderKeys[i].columnCode + ' ' + orderKeys[i].orderType + ', '
      }
      orderStr = orderStr.substr(0, orderStr.length - 2)

      return {
        error: '000000',
        columnInfo: columnInfo,
        tableInfo: tableInfo[0],
        disPlayColumnInfo: disPlayColumnInfo,
        orderStr: orderStr
      }
    } else {
      return { error: rtnObj.error, msg: rtnObj.msg }
    }
  },

  // 刷新表格结构信息
  refreshTableStructure: async function (that, tableName, noFreshData) {
    const table = that[tableName]
    table.Loading = true
    const tableStructure = await this.getColumnInfo(table.tableCode)
    if (tableStructure.error === '000000') {
      table.tableInfo = tableStructure.tableInfo
      table.columnInfo = tableStructure.columnInfo
      table.disPlayColumnInfo = tableStructure.disPlayColumnInfo
      table.orderStr = tableStructure.orderStr
      table.defaultOrderStr = tableStructure.orderStr
      table.pageSize = tableStructure.tableInfo.PageSize ? tableStructure.tableInfo.PageSize : 50
      if (!noFreshData) {
        that['refresh' + tableName.substr(0, 1).toUpperCase() + tableName.substr(1) + 'Content']()
      } else {
        table.Loading = false
      }
    } else {
      that.$message.error(tableStructure.msg)
    }
  },

  // 获取表格内容信息
  getTableContent: async function (tableCode, pageSize, page, orderStr, filterStr
    , detail1FilterStr, detail2FilterStr, detail3FilterStr) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/Table.GetTableContent', {
      filterDic: {
        pageSize: pageSize,
        page: page,
        orderKey: orderStr,
        filter: encodeURI(filterStr),
        detail1FilterStr: detail1FilterStr ? encodeURI(detail1FilterStr) : '',
        detail2FilterStr: detail2FilterStr ? encodeURI(detail2FilterStr) : '',
        detail3FilterStr: detail3FilterStr ? encodeURI(detail3FilterStr) : ''
      },
      tableCode: tableCode
    })
    if (rtnObj.error === '000000') {
      for (let i = 0; i < rtnObj.data.length; i++) {
        rtnObj.data[i].RowId = (page - 1) * pageSize + i + 1
      }
      return { error: '000000', tableContent: rtnObj.data, total: rtnObj.total }
    } else {
      return { error: rtnObj.error, msg: rtnObj.msg }
    }
  },

  // 刷新表格内容信息
  refreshTableContent: async function (that, tableName) {
    const table = that[tableName]
    table.Loading = true
    const getTableContentFnc = that[tableName + 'GetTableContentFnc']
    let tableContent = {}
    if (getTableContentFnc && typeof getTableContentFnc === 'function') {
      tableContent = await getTableContentFnc()
    } else {
      tableContent = await this.getTableContent(table.tableCode, table.pageSize, table.page
        , table.orderStr, table.filterStr + (table.customFilterStr ? table.customFilterStr : '')
        , table.detail1FilterStr, table.detail2FilterStr, table.detail3FilterStr)
    }
    if (tableContent.error === '000000') {
      table.tableContent = tableContent.tableContent
      table.total = tableContent.total
      if (table.spanColumns && table.spanColumns.length > 0) {
        this.spanColumns(that, tableName)
      }
    } else {
      that.$message.error(tableContent.msg)
    }
    table.Loading = false
  },

  // 特征字符串显示转换
  specialStringDisplayTransform: function (val, arys, code, name) {
    let thisCode = 'code'
    let thisName = 'name'
    if (code) {
      thisCode = code
    }
    if (name) {
      thisName = name
    }
    for (let i = 0; i < arys.length; i++) {
      if (val === arys[i][thisCode]) {
        return arys[i][thisName]
      }
    }
    return val
  },

  // 表格排序
  sortChange: function (column, that, tableName) {
    const table = that[tableName]
    let orderKey = column.prop
    if (column.order === 'ascending') {
      orderKey = orderKey + ' ASC'
    } else if (column.order === 'descending') {
      orderKey = orderKey + ' DESC'
    } else {
      return
    }
    if (table.orderStr === orderKey) {
      return
    }
    table.orderStr = orderKey
    that['refresh' + tableName.substr(0, 1).toUpperCase() + tableName.substr(1) + 'Content']()
  },

  // 表格合并行依赖计算
  spanColumns: function (that, tableName) {
    const table = that[tableName]
    const spanColumnsBasisKeys = Object.keys(table.spanColumnsBasis)
    table.spanColumnsBasisArys = {}
    const spanColumnsBasisIndexs = {}
    for (let i = 0; i < spanColumnsBasisKeys.length; i++) {
      table.spanColumnsBasisArys[spanColumnsBasisKeys[i]] = []
      spanColumnsBasisIndexs[spanColumnsBasisKeys[i]] = 0
    }
    for (let i = 0; i < spanColumnsBasisKeys.length; i++) {
      for (let j = 0; j < table.tableContent.length; j++) {
        if (j === 0) {
          table.spanColumnsBasisArys[spanColumnsBasisKeys[i]].push(1)
        } else {
          let hbFlag = true
          for (let k = 0; k <= table.spanColumnsBasis[spanColumnsBasisKeys[i]].length; k++) {
            if (table.tableContent[j][table.spanColumnsBasis[spanColumnsBasisKeys[i]][k]] !== table.tableContent[j - 1][table.spanColumnsBasis[spanColumnsBasisKeys[i]][k]]) {
              hbFlag = false
              break
            }
          }
          if (hbFlag) {
            table.spanColumnsBasisArys[spanColumnsBasisKeys[i]].push(0)
            table.spanColumnsBasisArys[spanColumnsBasisKeys[i]][spanColumnsBasisIndexs[spanColumnsBasisKeys[i]]]++
          } else {
            table.spanColumnsBasisArys[spanColumnsBasisKeys[i]].push(1)
            spanColumnsBasisIndexs[spanColumnsBasisKeys[i]] = j
          }
        }
      }
    }
  },

  // 表格行合并方法
  columnsSpanMethod: function ({ row, column, rowIndex, columnIndex }, that, tableName) {
    const table = that[tableName]
    for (let i = 0; i < table.spanColumns.length; i++) {
      if (column.property && column.property === table.spanColumns[i].name) {
        return [table.spanColumnsBasisArys[table.spanColumns[i].basis][rowIndex], 1]
      }
    }
  },

  // 展开行
  expandRow: function (that, tableName) {
    const table = that[tableName]
    table.expandRowKeys = []
    const rowKey = 'GUID'
    for (let i = 0; i < table.tableContent.length; i++) {
      table.expandRowKeys.push(table.tableContent[i][rowKey])
    }
  },

  // 折叠行
  narrowRow: function (that, tableName) {
    const table = that[tableName]
    table.expandRowKeys = []
  }
}
